import { type RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Login from "@/pages/login/page";
import SettingsPage from "@/pages/settings/page";
import SalesSettingsPage from "@/pages/settings/sales/page";
import BusinessSettingsPage from "@/pages/settings/business/page";
import BackupPage from "@/pages/settings/backup/page";
import ActivityLogsPage from "@/pages/settings/logs/page";
import SocialSettingsPage from "@/pages/settings/social/page";
import PrintersSettingsPage from "@/pages/settings/printers/page";
import DiagnosticsPage from "@/pages/settings/diagnostics/page";
import PosPage from "@/pages/pos/page";
import ProductsPage from "@/pages/products/page";
import NewProductPage from "@/pages/products/new/page";
import ProductDetailPage from "@/pages/products/detail/page";
import InventoryPage from "@/pages/inventory/page";
import SalesPage from "@/pages/sales/page";
import SaleDetailPage from "@/pages/sales/detail/page";
import CatalogPage from "@/pages/catalog/page";
import ClientsPage from "@/pages/clients/page";
import ReportsPage from "@/pages/reports/page";
import ProfitsPage from "@/pages/reports/ganancias/page";
import InvoicesPage from "@/pages/invoices/page";
import FiscalDashboardPage from "@/pages/fiscal/page";
import FiscalErrorsPage from "@/pages/fiscal/errors/page";
import BranchesPage from "@/pages/branches/page";
import UsersPage from "@/pages/users/page";
import ImportPage from "@/pages/products/import/page";
import DiscountsPage from "@/pages/discounts/page";
import OffersPage from "@/pages/offers/page";
import WholesalePage from "@/pages/wholesale/page";
import CashRegisterPage from "@/pages/cash/page";
import CashSupervisionPage from "@/pages/cash/supervision/page";
import AuthGuard from "@/components/feature/AuthGuard";
import AdminGuard from "@/components/feature/AdminGuard";
import AdminLayout from "@/components/feature/AdminLayout";

const routes: RouteObject[] = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    // Ruta publica del catalogo. React Router resuelve /catalogo y /catalogo/
    // con la misma ruta, por eso NO se define un alias con barra final
    // (un alias duplicado hacia <Navigate> deja la pagina en blanco).
    path: "/catalogo",
    element: <CatalogPage />,
  },
  {
    path: "/",
    element: (
      <AuthGuard>
        <AdminLayout>
          <Home />
        </AdminLayout>
      </AuthGuard>
    ),
  },
  {
    path: "/pos",
    element: (
      <AuthGuard>
        <AdminLayout>
          <PosPage />
        </AdminLayout>
      </AuthGuard>
    ),
  },
  {
    path: "/products",
    element: (
      <AdminGuard>
        <AdminLayout>
          <ProductsPage />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/products/new",
    element: (
      <AdminGuard>
        <AdminLayout>
          <NewProductPage />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/products/import",
    element: (
      <AdminGuard>
        <AdminLayout>
          <ImportPage />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/products/:id",
    element: (
      <AdminGuard>
        <AdminLayout>
          <ProductDetailPage />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/inventory",
    element: (
      <AdminGuard>
        <AdminLayout>
          <InventoryPage />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/sales",
    element: (
      <AuthGuard>
        <AdminLayout>
          <SalesPage />
        </AdminLayout>
      </AuthGuard>
    ),
  },
  {
    path: "/sales/:id",
    element: (
      <AuthGuard>
        <AdminLayout>
          <SaleDetailPage />
        </AdminLayout>
      </AuthGuard>
    ),
  },
  {
    path: "/clients",
    element: (
      <AuthGuard>
        <AdminLayout>
          <ClientsPage />
        </AdminLayout>
      </AuthGuard>
    ),
  },
  {
    path: "/reports",
    element: (
      <AdminGuard>
        <AdminLayout>
          <ReportsPage />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/reports/ganancias",
    element: (
      <AuthGuard>
        <AdminLayout>
          <ProfitsPage />
        </AdminLayout>
      </AuthGuard>
    ),
  },
  {
    path: "/invoices",
    element: (
      <AdminGuard>
        <AdminLayout>
          <InvoicesPage />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/fiscal",
    element: (
      <AdminGuard>
        <AdminLayout>
          <FiscalDashboardPage />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/fiscal/errors",
    element: (
      <AdminGuard>
        <AdminLayout>
          <FiscalErrorsPage />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/branches",
    element: (
      <AdminGuard>
        <AdminLayout>
          <BranchesPage />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/users",
    element: (
      <AdminGuard>
        <AdminLayout>
          <UsersPage />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/discounts",
    element: (
      <AdminGuard>
        <AdminLayout>
          <DiscountsPage />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/offers",
    element: (
      <AdminGuard>
        <AdminLayout>
          <OffersPage />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/wholesale",
    element: (
      <AdminGuard>
        <AdminLayout>
          <WholesalePage />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/cash",
    element: (
      <AuthGuard>
        <AdminLayout>
          <CashRegisterPage />
        </AdminLayout>
      </AuthGuard>
    ),
  },
  {
    path: "/cash/supervision",
    element: (
      <AdminGuard>
        <AdminLayout>
          <CashSupervisionPage />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/settings",
    element: (
      <AdminGuard>
        <AdminLayout>
          <SettingsPage />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/settings/sales",
    element: (
      <AdminGuard>
        <AdminLayout>
          <SalesSettingsPage />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/settings/business",
    element: (
      <AdminGuard>
        <AdminLayout>
          <BusinessSettingsPage />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/settings/printers",
    element: (
      <AdminGuard>
        <AdminLayout>
          <PrintersSettingsPage />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/settings/backup",
    element: (
      <AdminGuard>
        <AdminLayout>
          <BackupPage />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/settings/logs",
    element: (
      <AdminGuard>
        <AdminLayout>
          <ActivityLogsPage />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/settings/diagnostics",
    element: (
      <AdminGuard>
        <AdminLayout>
          <DiagnosticsPage />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/settings/social",
    element: (
      <AdminGuard>
        <AdminLayout>
          <SocialSettingsPage />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;